<template>
  <div class="parent-master-div">
      <div class="main-menu">
          <div class="links-div">
            <router-link 
                class="link" 
                :class="{'active-page':$route.name==='UserHome'}"
                to="/korisnik">
                Почетна Страна
            </router-link>
            <router-link
                class="link" 
                :class="{'active-page':$route.name==='UserHistory'}"
                to="/korisnik/istorijat">
                Историјат Захтева
            </router-link>
          </div>
        <div class="main-buttons">
            <span @click="passChangePopupToggle">Промени Лозинку</span>
            <span @click="logOut">Одјави се</span>
        </div>
      </div>
      
      <div>
        <router-view/>
      </div>

      <pass-change-popup-comp
        v-if="passChangePopup"
        @close="passChangePopupToggle">
      </pass-change-popup-comp>
  </div>
</template>

<script>
import PassChangePopupComp from '@/components/PassChangePopupComp'
import extraData from '../extraData.js'
import axios from 'axios'

export default {
    components:{
        PassChangePopupComp
    },
    data(){
        return {
            passChangePopup: false
        }
    },
    methods:{
        passChangePopupToggle(){
            this.passChangePopup=!this.passChangePopup
        },
        logOut(){
            axios.get(extraData.adress+"login",{
                params:{
                    sid: sessionStorage.getItem("sid")
                }
            }).then(()=>{
                // console.log(res);
                sessionStorage.removeItem("sid");
                sessionStorage.removeItem("admin");
                sessionStorage.removeItem("selectedProId");
                this.$router.push("/");
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .main-menu{
        background-color: $primaryColor;
        @include MainMenu();
    }
    @media only screen and (max-width: 768px) {
        .main-menu{
            flex-direction: column;
        }
        .links-div{
            margin: 20px auto;
            >.link{
                margin: 0;
            }
        }
        .main-buttons{
            margin: 20px auto;
            >span{
                margin: 0;
            }
        }
    }
</style>